"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _Button = _interopRequireDefault(require("../Button"));
function BasicConfirmDialog(props) {
  var isOpen = props.isOpen,
    onClose = props.onClose,
    onConfirm = props.onConfirm,
    children = props.children,
    confirmTexti18nKey = props.confirmTexti18nKey;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  function handleOnCancel() {
    onClose();
  }
  function handleOnConfirm() {
    onConfirm && onConfirm();
  }
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    fullWidth: true,
    onClose: onClose,
    open: isOpen
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col flex-1 w-full p-8"
  }, children, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-16"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "secondary",
    onClick: handleOnCancel,
    className: "w-32 !py-3 mr-4"
  }, t('button.cancel')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "warning",
    className: "w-32 !py-3",
    onClick: function onClick() {
      return handleOnConfirm();
    }
  }, confirmTexti18nKey ? t(confirmTexti18nKey) : 'button.confirm'))));
}
var _default = exports["default"] = BasicConfirmDialog;
//# sourceMappingURL=index.js.map